var AbstractAttributesDialog = require("../attributes/AbstractAttributesDialog");
var Utils = require("common/Utils");

/**
 * @extends {AbstractAttributesDialog}
 * @class
 */
function AuthenticationDialog() {
    var $htmlForm = $(require("html!./authentication_dialog.html"));
    AbstractAttributesDialog.call(this, $htmlForm);

    this.setSubmitEvent("AuthenticationController", "post-authentication-credentials");

    var super_promptForAttributes = this.promptForAttributes;

    this.promptForAttributes = function(launchId, launchCallback, title) {
        var attributes = {
            session : [
                {
                    id : "VFSUsername",
                    label : $.t("common::login.username"),
                    value : "",
                    format : 0
                }, {
                    id : "VFSPassword",
                    label : $.t("common::login.password"),
                    value : "",
                    format : 4
                }
            ]
        };

        return super_promptForAttributes(attributes, launchId, launchCallback, title, false);
    };
}

Utils.inherits(AuthenticationDialog, AbstractAttributesDialog);

module.exports = AuthenticationDialog;